module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAABWElEQVQ4T9XTP0iVYRTH8c/VsMElF5ts01Eaw9H+EJqI2BQRiItKS1PaLFHQ1mRTDrU4lpNQpENLgzi4OEg4OBRJGFII3ThwLrxc3vteFRo80/s+zznf55zzO6dWr9dr/oPVzgM4Kq83ii9m/Bh9eHiGztzCIkbwPeIb4KeYT+AzPDkF/A5WcBGbuI6DAHdgGfcLsAU8PwF8Em/Qlb67GMbXRsYX8tXxdIhezWGpAn4PrxGxYTu4gb1iK+I7SnmfpcT/XzzA2xL4FF6hM++2cRP7ZeLFWTfWcC0djnEX7wrwWbxEtDBsK6HfigmUzXEPPmIwHX9jNM8e4UWInndfcBs/mqtqtSCXsY7+DDhMkWYKgM85Xj/LdKjavCvYyNlujv2EMfxqJW67lR7IzHsLgNBgAkdV49gOHLFX8QGXsJpi/qmCNo9ble8Qor/TiElpayfJuC2kzOEfT2hl8dk3gIMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/btn_open_video.png
// module id = 768
// module chunks = 2